import { useCallback, useRef, useState } from "react";

export const useConfirmDialog = () => {
  const [isOpen, setIsOpen] = useState(false);
  // One answer per opening: the dialog stays clickable while it fades out, so a double-click
  // would otherwise confirm twice.
  const isAnsweredRef = useRef(true);

  const handleResult = useCallback(
    (successCallback?: () => void) => (wasConfirmed: boolean) => {
      if (isAnsweredRef.current) {
        return;
      }
      isAnsweredRef.current = true;
      setIsOpen(false);

      if (wasConfirmed && successCallback) {
        successCallback();
      }
    },
    [],
  );

  const open = useCallback(() => {
    isAnsweredRef.current = false;
    setIsOpen(true);
  }, []);

  return {
    isOpen,
    handleResult,
    open,
  };
};
